window.axios = require('axios');
window.Vue = require('vue');


import Modal from './components/RoomModal';
import ModernAlert from './components/ModernAlert';
import NavBar from './components/NavBar'

Vue.config.productionTip = false;

new Vue({
    components: {
        ModernAlert,
        Modal,
        NavBar
    },
})
    // .$mount('#app');

